import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {BruteForce} from "../BruteForce";
import {BruteForceSymbol, BruteForceSymbolStates} from "../reels/BruteForceSymbol";
import {SimpleReelModelSymbolData} from "../../core/reel/simplereel/SimpleReelModel";
import {gsap} from "gsap";
import {BruteForceXNudgeSymbol} from "../reels/BruteForceXNudgeSymbol";
import {BruteForceGameMode} from "../server/BruteForceGameMode";

export class BruteForceIndividualWinView extends PIXI.Container implements StageLayer {


    constructor() {
        super();
        this.name = "BruteForceIndividualWinView";
    }

    public showLines(): gsap.core.Timeline {

        const wintl: gsap.core.Timeline = gsap.timeline();
        //adding betline of each type
        BruteForce.model.winLinesIndexArray.forEach((value: number, index) => {
            BruteForce.betlineView.addBetLine(value, index);
        });
        BruteForce.betlineView.betlineGroupOrdering();

        //nudgeMultiplier alpha setting
        if (BruteForce.model.mode === BruteForceGameMode.FREESPIN_SUPER) {
            if (BruteForce.model.isXNPartOfWin.includes(true)) {
                if (BruteForce.model.toNudge.includes(true)) {
                    BruteForce.gameContainer.setAlphaForNudgeMultiplier(1);
                } else {
                    let setCurrentValue: number = 0;
                    BruteForce.model.isXNPartOfWin.forEach((winNudge: boolean, reelId: number) => {
                        if (winNudge && !BruteForce.model.toNudge[reelId]) {
                            setCurrentValue += BruteForce.model.xNudgeMultipliers[reelId];
                        }
                    });
                    BruteForce.gameContainer.fadeNudgeMultiplier(setCurrentValue, 1);
                }
            } else {
                BruteForce.gameContainer.setAlphaForNudgeMultiplier(0.6);
            }
        }

        if (!BruteForce.model.gameData.brokeTheBank) {
            //putting all sym to no win state
            BruteForce.model.allWinPositions.forEach((item: boolean[], reelNo: number) => {
                const currentSyms: SimpleReelModelSymbolData[] = BruteForce.allreelsView.reelModels[reelNo].symbols;
                currentSyms.forEach((data: SimpleReelModelSymbolData) => {
                    const sym: BruteForceSymbol = <BruteForceSymbol>data.positionable;
                    const singleSymTl: gsap.core.Timeline = gsap.timeline();
                    singleSymTl.add(sym.setState(BruteForceSymbolStates.NO_WIN));
                    wintl.add(singleSymTl, 0);
                });
            });
            // return one win toggle anim and in end all winning syms are put to win state
            wintl.add(BruteForce.betlineView.showBetLine(false), ">");
            wintl.addLabel("winLinesOver");
            wintl.to(this,{duration:0.05});
                BruteForce.model.gameData.betLineWins.forEach((value, id: number) => {
                    BruteForce.model.currentPaylines[id].forEach((symPos: number, reelNo: number) => {
                        if (reelNo < BruteForce.model.betLineWins[id].length) {
                            let sym: BruteForceSymbol | BruteForceXNudgeSymbol;
                            if (BruteForce.model.allWinPositions[reelNo][symPos]) {
                                // symHighlightArray.push(sym);
                                if (BruteForce.model.gameData.evaluatedArea[reelNo][symPos] !== "XN") {
                                    sym = <BruteForceSymbol>BruteForce.allreelsView.reelModels[reelNo].getStopSymbolAt(symPos);
                                    wintl.add(sym.setState(BruteForceSymbolStates.NORMAL),"winLinesOver");
                                } else {
                                    sym = <BruteForceXNudgeSymbol>BruteForce.allreelsView.reelModels[reelNo].getStopSymbolAt(0);
                                }
                            }
                        }
                    });
                });
            wintl.to(this, {duration: 0.05});
            return wintl;
        } else {
            return gsap.timeline().to(this, {duration: 0.01});
        }
    }

}